/**
 * Onboarding "what do you want to bring into your hub?" step for the
 * real-estate signup funnel. Mirrors the `{slug, name}` shape of
 * `EchoPreference` (see `echo-preference.ts`).
 */
export enum RealEstateGoalSlug {
  CaptureLeads = 'capture_leads',
  ImportListings = 'import_listings',
  BookShowings = 'book_showings',
  CreateGuides = 'create_guides',
  SyncCrm = 'sync_crm',
  SellWithoutBeingSalesy = 'sell_without_being_salesy',
}

export interface RealEstateGoal {
  slug: RealEstateGoalSlug;
  name: string;
}
